import { ReactNode, createContext, useContext } from "react";

// Define the generic type for the context value
type WrapperLayerContextValue = {
	isDisabled: boolean;
};

// Define the context with a default value
export const WrapperLayerContext = createContext<WrapperLayerContextValue>({
	isDisabled: false,
});

interface WrapperLayerProviderProps {
	children: ReactNode;
	value: WrapperLayerContextValue;
}

function WrapperLayerProvider({ children, value }: Readonly<WrapperLayerProviderProps>) {
	return <WrapperLayerContext.Provider value={value}>{children}</WrapperLayerContext.Provider>;
}

function useWrapperLayer() {
	const context = useContext(WrapperLayerContext);
	if (context === undefined) {
		throw new Error("useWrapperLayer must be used within a WrapperLayerProvider");
	}
	return context;
}

export { WrapperLayerProvider, useWrapperLayer };
